import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
  UnorderedList,
  ListItem,
  useColorModeValue,
} from '@chakra-ui/react';

import type { RatingNote } from 'api/quote-marketplace';

interface MessageBoxProps {
  title: string;
  items: string[];
  mb?: number;
  accent?: 'red' | 'green';
}

export const MessageBox = ({
  title,
  items,
  mb = 6,
  accent = 'red',
}: MessageBoxProps) => {
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  const headerBg = useColorModeValue('gray.50', 'gray.700');
  const redBg = useColorModeValue('red.200', 'red.900');
  const greenBg = useColorModeValue('green.200', 'green.900');
  const cellBg = accent === 'green' ? greenBg : redBg;

  if (items.length === 0) {
    return null;
  }

  return (
    <Box mb={mb}>
      <Table
        size="sm"
        variant="simple"
        borderWidth="1px"
        borderColor={borderColor}
      >
        <Thead>
          <Tr>
            <Th
              bg={headerBg}
              borderColor={borderColor}
              fontSize="xs"
              textTransform="uppercase"
            >
              {title}
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          <Tr>
            <Td borderColor={borderColor} verticalAlign="top" bg={cellBg} p={3}>
              <UnorderedList spacing={1} ml={4}>
                {items.map((item, idx) => (
                  <ListItem key={idx} fontSize="sm">
                    <Text whiteSpace="pre-wrap">{item}</Text>
                  </ListItem>
                ))}
              </UnorderedList>
            </Td>
          </Tr>
        </Tbody>
      </Table>
    </Box>
  );
};

interface MessagesSectionProps {
  ratingNotes: RatingNote[] | null;
}

const MessagesSection = ({ ratingNotes }: MessagesSectionProps) => {
  const messages = (ratingNotes || []).map((note) => note.description);

  return <MessageBox title="Messages" items={messages} />;
};

export default MessagesSection;
